/**
 * ValidationMessagesForm - Módulo para el manejo del formulario de mensajes de validación
 */
import $ from 'jquery';
import 'select2';
export class ValidationMessagesForm {
    constructor() {
        this.FORM_ID = '#validationMessageForm';
        this.form = null;
        this.baseUrl = window.location.origin;
        this.init();
    }
    init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.initializeModule();
            });
        }
        else {
            this.initializeModule();
        }
    }
    initializeModule() {
        this.form = document.querySelector(this.FORM_ID);
        if (!this.form) {
            console.warn('ValidationMessagesForm element not found');
            return;
        }
        this.setupEventListeners();
        this.setupCharacterCounter();
        this.setupColorPreview();
        this.setupUserSelect();
    }
    setupEventListeners() {
        if (!this.form)
            return;
        // Manejar el envío del formulario
        this.form.addEventListener('submit', (e) => {
            this.handleFormSubmit(e);
        });
        // Manejar cambios en el campo de color para mostrar vista previa
        const colorSelect = document.querySelector('#div_color');
        if (colorSelect) {
            colorSelect.addEventListener('change', () => {
                this.updateColorPreview();
            });
        }
    }
    setupCharacterCounter() {
        const messageTextarea = document.querySelector('#message');
        if (!messageTextarea)
            return;
        // Crear contador de caracteres
        const counter = document.createElement('small');
        counter.className = 'form-text text-muted';
        counter.id = 'messageCounter';
        messageTextarea.parentElement?.appendChild(counter);
        // Actualizar contador
        const updateCounter = () => {
            const currentLength = messageTextarea.value.length;
            const minLength = 10;
            const maxLength = 1000;
            if (currentLength < minLength) {
                counter.className = 'form-text text-danger';
                counter.textContent = `${currentLength}/${maxLength} caracteres (mínimo ${minLength})`;
            }
            else if (currentLength > maxLength * 0.9) {
                counter.className = 'form-text text-warning';
                counter.textContent = `${currentLength}/${maxLength} caracteres`;
            }
            else {
                counter.className = 'form-text text-muted';
                counter.textContent = `${currentLength}/${maxLength} caracteres`;
            }
        };
        messageTextarea.addEventListener('input', updateCounter);
        updateCounter(); // Inicializar
    }
    setupColorPreview() {
        this.updateColorPreview();
    }
    updateColorPreview() {
        const colorSelect = document.querySelector('#div_color');
        if (!colorSelect)
            return;
        const selectedColor = colorSelect.value;
        // Actualizar vista previa si existe
        const previewContainer = document.querySelector('#colorPreview');
        if (previewContainer) {
            const alertDiv = previewContainer.querySelector('.alert');
            if (alertDiv) {
                // Remover todas las clases de color
                alertDiv.className = 'alert';
                // Agregar la clase seleccionada
                alertDiv.classList.add(`alert-${selectedColor}`);
            }
        }
    }
    handleFormSubmit(e) {
        if (!this.form)
            return;
        e.preventDefault();
        // Validar longitud del mensaje
        const messageTextarea = this.form.querySelector('#message');
        if (messageTextarea) {
            const message = messageTextarea.value.trim();
            if (message.length < 10) {
                this.showError('El mensaje debe tener al menos 10 caracteres.');
                return;
            }
            if (message.length > 1000) {
                this.showError('El mensaje no puede exceder 1000 caracteres.');
                return;
            }
        }
        // Validar que se seleccione un usuario
        const userSelect = this.form.querySelector('#id_user');
        if (userSelect && !userSelect.value) {
            this.showError('Debe seleccionar un usuario.');
            return;
        }
        // Validar que se seleccione un color
        const colorSelect = this.form.querySelector('#div_color');
        if (colorSelect && !colorSelect.value) {
            this.showError('Debe seleccionar un color para el mensaje.');
            return;
        }
        // Si todas las validaciones pasan, enviar el formulario
        this.form.submit();
    }
    setupUserSelect() {
        const userSelect = $('#id_user');
        if (!userSelect.length)
            return;
        // Inicializar Select2
        userSelect.select2({
            theme: 'bootstrap-5',
            width: '100%',
            placeholder: 'Selecciona un usuario',
            allowClear: false,
            minimumResultsForSearch: 1,
            language: {
                noResults: function () {
                    return 'No se encontraron usuarios';
                },
                searching: function () {
                    return 'Buscando...';
                },
                inputTooShort: function () {
                    return 'Ingresa al menos 1 carácter';
                }
            },
            templateResult: this.formatUserResult,
            templateSelection: this.formatUserSelection,
            escapeMarkup: function (markup) {
                return markup;
            }
        });
        // Agregar clase personalizada al contenedor de Select2
        userSelect.on('select2:open', function () {
            const searchField = $('.select2-search__field');
            if (searchField.length) {
                searchField.attr('placeholder', 'Buscar usuario...');
            }
        });
        // Manejar el cambio de valor para validar
        userSelect.on('change', function () {
            const value = $(this).val();
            if (value) {
                $(this).removeClass('is-invalid');
                $(this).addClass('is-valid');
            }
            else {
                $(this).removeClass('is-valid');
                $(this).addClass('is-invalid');
            }
        });
        // Inicializar estado de validación si hay un valor preseleccionado
        if (userSelect.val()) {
            userSelect.removeClass('is-invalid').addClass('is-valid');
        }
    }
    formatUserResult(user) {
        if (!user.id) {
            return $(`<span class="select2-placeholder">${user.text}</span>`);
        }
        // El texto del option es "email - nombre"
        const text = user.text || '';
        const parts = text.split(' - ');
        const email = parts[0] || '';
        const name = parts[1] || email;
        return $(`
            <div class="select2-user-result">
                <div class="d-flex align-items-center">
                    <div class="user-avatar me-2">
                        <i class="bi bi-person-circle fs-5"></i>
                    </div>
                    <div>
                        <div class="user-name">${name}</div>
                        <div class="user-email text-muted small">${email}</div>
                    </div>
                </div>
            </div>
        `);
    }
    formatUserSelection(user) {
        if (!user.id) {
            return user.text;
        }
        // El texto del option es "email - nombre"
        const text = user.text || '';
        const parts = text.split(' - ');
        const email = parts[0] || '';
        const name = parts[1] || email;
        // Mostrar solo el nombre si está disponible, sino el email
        const displayName = name || email;
        return $(`
            <div class="d-flex align-items-center">
                <i class="bi bi-person-circle me-1"></i>
                <span>${displayName}</span>
            </div>
        `);
    }
    showError(message) {
        // Eliminar alertas anteriores
        const existingAlert = document.querySelector('.alert-danger.form-alert');
        if (existingAlert) {
            existingAlert.remove();
        }
        // Crear nueva alerta
        const alert = document.createElement('div');
        alert.className = 'alert alert-danger form-alert';
        alert.innerHTML = `
            <i class="bi bi-exclamation-triangle me-2"></i>
            ${message}
        `;
        // Insertar antes del formulario
        if (this.form) {
            this.form.parentElement?.insertBefore(alert, this.form);
            // Remover después de 5 segundos
            setTimeout(() => {
                alert.remove();
            }, 5000);
        }
    }
}
export default ValidationMessagesForm;
